module.exports = __webpack_public_path__ + "6a595b96512e5d403a6f5b5e68b2b03b.fbx";